import { isNative, sendToNative } from '@/shared/bridge';
import { getResolvedTheme, subscribeResolvedTheme } from '@/shared/stores';

/**
 * 테마의 **native 셸 동기화** — 테마 주인은 web(localStorage 선택 + `.dark` 클래스)이라, 상태바 글자색과
 * 시스템 배경(세이프에어리어·오버스크롤 영역)을 쥔 native 는 통지받지 않으면 알 수 없다.
 * 동기화가 없으면 다크 화면에 밝은 상태바·흰 가장자리가 남는다.
 *
 * 보내는 값은 **해석된 테마**(`system` → OS 판정 결과) — 판정을 web 한 곳에서만 한다.
 * 부팅 시 1회 밀어주고(native 기본값 light 와 어긋난 상태로 시작하는 경우 정정), 이후 변화만 통지한다.
 * 브라우저(비 WebView)에서는 no-op.
 */
export function bindNativeThemeSync(): () => void {
  if (!isNative()) return () => {};
  const push = (theme: 'light' | 'dark') =>
    sendToNative({ type: 'systemUi.setTheme', payload: { theme } });
  push(getResolvedTheme());
  return subscribeResolvedTheme(push);
}
